import React, { useEffect } from 'react';
import { View } from 'react-native';

const FormContainer = ({ onEnter, children }) => {
  useEffect(() => {
    const handleKeyUp = (e) => {
      if (13 === e.keyCode && onEnter) {
        onEnter();
      }
    }

    if (window.document) {
      window.document.addEventListener('keyup', handleKeyUp);
    }

    return () => {
      if (window.document) {
        window.document.removeEventListener('keyup', handleKeyUp);
      }
    }
  }, [onEnter]);

  return (
    <View>{children}</View>
  )
};

export default FormContainer;
